import { render, staticRenderFns } from "./FinanceCreditScoring.vue?vue&type=template&id=5201be9c&"
import script from "./FinanceCreditScoring.vue?vue&type=script&lang=js&"
export * from "./FinanceCreditScoring.vue?vue&type=script&lang=js&"
import style0 from "./FinanceCreditScoring.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports